<template>
  <b-modal id="notes-modal" title="Notes" hide-footer no-close-on-backdrop @shown="getItems" @hidden="clearData">
      <p class="small mb-4 text-uppercase text-center" v-if="notes && notes.length == 0"><strong>There are currently no notes for this {{ type }}.</strong></p>
      <b-list-group flush class="my--3" id="notesList">
        <b-list-group-item class="px-0"
            v-for="note in notes"
            :key="note.id"
        >
          <b-row align-v="center">
            <b-col>
              <h4 class="mb-0">
                {{ note.author.name }}
                <small> &ndash; {{ new Date(note.date) | date('M/d/Y h:mm a')}}</small>
              </h4>
              <p class="small mb-1">{{ note.content }}</p>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
      <hr />
      <b-form @submit.prevent="store">
        <Mentionable
            :keys="['@']"
            :items="users"
            offset="6"
            insert-space
            @open="onOpen"
            @apply="onApply"
          >
          <b-input-group size="sm">
            <b-form-input v-model="note" placeholder="Type Note..." size="sm" required></b-form-input>
            <b-input-group-append>
              <b-button size="sm" type="submit" variant="success">Submit</b-button>
            </b-input-group-append>
          </b-input-group>
          <p class="small text-danger"><em>To notify a user, mention them using @</em></p>

          <template #no-result>
            <div class="dim">
              No result
            </div>
          </template>
        </Mentionable>
      </b-form>
  </b-modal>
</template>

<script>
import axios from 'axios';
import 'floating-vue/dist/style.css';
import { Mentionable } from 'vue-mention';

export default {
  props: {
    type: null,
    typeId: null,
    userRoute: null,
  },
  components: {
    Mentionable
  },
  data: function() {
    return {
      notes: null,
      note: null,
      notify: null,
      users: [],
      items: [],
    }
  },
  methods: {
    async getItems() {
      await axios.get(this.userRoute + '/notes/' + this.type + "/" + this.typeId)
        .then(response => {
          this.notes = response.data;
        });
    },
    async getTeamUsers() {
      await axios.get(this.userRoute + '/mentionable-users')
      .then(response => {
        this.users = response.data;
      });
    },
    async store() {
      await axios.post(this.userRoute + '/notes/' + this.type + "/" + this.typeId, {
        note: this.note,
        notify: this.notify,
        type: this.type,
        typeId: this.typeId
      }).then(response => {
          this.note = null;
          this.getItems();
      });
    },
    clearData() {
      this.notes = null,
      this.note = null
    },
    onOpen (key) {
      this.items = key === '@' ? this.users : [];
    },
    onApply (item, key, replacedWith) {
      this.notify = item.email;
    }
  },
  created() {
    this.getTeamUsers();
  }
};
</script>

<style>
#notesList {
  max-height: 350px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.mention-item {
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 11px;
}

.mention-selected {
  background: rgb(192, 250, 153);
}
</style>